import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import redirector from "../../../util/redirector";

import EindPageHelper from "./EindPageHelper";
import EindForm from "./EindForm";

class EindPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {};

        this.pageHelper = new EindPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnGoToFirstTab = () => this.pageHelper.goToFirstTab();

    render() {
        return (
            <EindForm
                goToFirstTab={this.handleOnGoToFirstTab}
                sportVlaanderenRoot={this.props.sportVlaanderenRoot}
            />
        );
    }
}

EindPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        sportVlaanderenRoot: state.settings.sportVlaanderenRoot
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadNieuweSportclubEindPageLayout, dispatch),

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EindPage);